import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Marquee from "react-fast-marquee";
import Hero from '../hero/hero';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from '../container/container'
import homeStyles from './home.module.scss';

const newsDetails = [
    {
        title: 'Title1',
        url: 'pic1.jpeg',
        text: "Arab Technical Company Ltd. is excited to announce our engineering partnership with Taif University’s Research and Consulting Center, leveraging Dr. Hamad Al-Mojaba's expertise for specialized consultations in infrastructure and railways.This partnership enhances our project quality and aligns with Vision 2030."
    },
    {
        title: 'Title2',
        url: 'pic2.jpeg',
        text: 'New collaboration between ArabTech, United CM, and Taif University.'
    },
]

const clientsLogo = [
    {
        alt: "Aramco logo",
        url: "aramcoLogo.svg"
    },
    {
        alt: "Sabic logo",
        url: "sabicLogo.svg"
    },
    {
        alt: "SEC logo",
        url: "secLogo.svg"
    },
    {
        alt: "ABB logo",
        url: "ABBLogo.svg"
    },
    {
        alt: "KJO Logo",
        url: "kjoLogo.svg"
    },
    {
        alt: "Samsung logo",
        url: "samsungLogo.svg"
    },
    {
        alt: "SANG logo",
        url: "snagLogo.svg"
    },
    {
        alt: "Sasref Logo",
        url: "sasrefLogo.svg"
    },
    {
        alt: "Maaden Logo",
        url: "maadenLogo.svg"
    },
    {
        alt: "Hitachi Logo",
        url: "hitachiLogo.svg"
    },
    {
        alt: "RCJY logo",
        url: "rcjyLogo.svg"
    },
    {
        alt: "Jedco logo",
        url: "jedcoLogo.svg"
    },
]

export default function Home() {
    const { t, i18n } = useTranslation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={homeStyles.home}>
            <div className={homeStyles.hero}>
                <Hero />
            </div>

            <Container>
                <div className={homeStyles.section_home}>

                    {/* About Section */}
                    <div className={`${homeStyles.about} ${i18n.language === 'ar' ? homeStyles.about_ar : ''}`}>
                        <h1 className={homeStyles.section_title}>{t('homeBrief')}</h1>
                        {i18n.language === 'en' ?
                            <p className={homeStyles.about_txt}>
                                Since its creation, <b>ArabTech</b> has evolved into a multi-disciplined organization comprised of multiple divisions and affiliates. This evolution was inspired by the growing needs of customers all over the kingdom.
                            </p>
                            :
                            <p className={homeStyles.about_txt}>
                                منذ إنشائها، تطورت شركة التقنية العربية إلى منظمة متعددة التخصصات تتألف من أقسام وشركات تابعة متعددة. وقد استلهم هذا التطور من الاحتياجات المتزايدة للعملاء في جميع أنحاء المملكة.
                            </p>
                        }

                        <Link to="/about" className={homeStyles.about_btn}>{t('readMore')}</Link>
                    </div>

                    {/* News Section */}
                    <div className={`${homeStyles.news} ${i18n.language === 'ar' ? homeStyles.news_ar : ''}`}>
                        <h1 className={homeStyles.section_title}>{t('latestNews')}</h1>
                        <div className={homeStyles.news_container}>
                            <NewsDetails news={newsDetails} isMobile={isMobile} />
                        </div>
                    </div>

                    {/* Clients Section */}
                    <div className={`${homeStyles.client_logo} ${i18n.language === 'ar' ? homeStyles.client_logo_ar : ''}`}>
                        <h1 className={homeStyles.section_title}>{t('ourClients')}</h1>
                        <div className={homeStyles.logo_slider}>
                            <LogoContainer logo={clientsLogo} extension="clients" dir='left' isMobile={isMobile} />
                        </div>
                    </div>
                </div>
            </Container >
        </div>
    )
}

function NewsDetails({ news, isMobile }) {
    if (isMobile) {
        return (
            <div className={homeStyles.news_mobile}>
                {news.map((n, index) => (
                    <div key={index} className={homeStyles.news_card}>
                        <div className={homeStyles.news_img_box}>
                            <img src={`../images/home/${n.url}`} alt={n.title} className={homeStyles.news_img} />
                        </div>
                        <div className={homeStyles.news_txt_box}>
                            <p className={homeStyles.news_description}>
                                {n.text}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <Marquee pauseOnHover speed={60} gradient={false}>
            {news.map((n, index) => (
                <div key={index} className={homeStyles.news_item}>
                    <div className={homeStyles.news_content}>
                        <div className={homeStyles.news_txt_box}>
                            <p className={homeStyles.news_description}>
                                {n.text}
                            </p>
                        </div>
                        <div className={homeStyles.news_img_box}>
                            <img src={`../images/home/${n.url}`} alt={n.title} className={homeStyles.news_img} />
                        </div>
                    </div>
                </div>
            ))}
        </Marquee>
    );
}

function LogoContainer({ logo, extension, dir, isMobile }) {
    const speed = isMobile ? 50 : 30;

    return (
        <Marquee pauseOnHover speed={speed} direction={dir} gradient={false}>
            {logo.map((l, index) => (
                <div key={index} className={homeStyles.logo_item}>
                    <img src={`../images/logo/${extension}/${l.url}`} alt={l.alt} loading="lazy" />
                </div>
            ))}
        </Marquee>
    );
}